export default __webpack_public_path__ + "static/media/2N.9783fa1f.jpg";